export const palette = {
  red: '#FF0000',
  orange: '#FFA500',
  yellow: '#FFFF00',
  green: '#008000',
  blue: '#0000FF',
  violet: '#EE82EE',
  white: '#FFFFFF',
  black: '#000000',
  pink: '#DF8383',
  gray: '#BABABA',
  gray_02: '#DEDEDE',
  gray_03: '#FAFAFA',
  light_gray: '#ECECEC',
  dark_gray: '#6A6A6A',
  crimson: '#BC323B',
  background: '#F6F6F6',
  indigo: '#17395C',
  none: '#ffffff00',
};
